import useProductSchemaStore from '../../store/productSchemaStore';
import { getApiUrl } from '../../libs/api';

export function useProductEngineScope(props) {
  const tenantId = useProductSchemaStore((state) => state.activeTenantId);
  const schemaSetVersion = useProductSchemaStore(
    (state) => state.schemaSetVersion
  );
  return {
    hostId: `client-portal:${getApiUrl?.() || window.location.origin}`,
    tenantId: props.tenantId ?? tenantId ?? localStorage.getItem('tenantId'),
    schemaContext:
      props.schemaContext ?? schemaSetVersion ?? props.structureVersionId,
  };
}
